import { Component, OnInit, signal } from '@angular/core';
import { CustomToastrService, ToastrStatus } from '@app/shared/custom-toastr/custom-toastr.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { registerIconLibrary } from '@quartzds/core'
import { environment } from '@env/environment';
import { Logger, I18nService, AuthenticationService } from '@app/core';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  readonly theme = signal<'light' | 'dark'>('light');
  toastrState = { status: 'success' as ToastrStatus, message: '', show: false };

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly translateService: TranslateService,
    private readonly i18nService: I18nService,
    private toastrService: CustomToastrService,
    private readonly authService: AuthenticationService
  ) {
    registerIconLibrary('default', {
      resolver: (name) => `assets/${name}.svg`,
    });
    registerIconLibrary('core', {
      resolver: (name) => `assets/${name}.svg`,
    });

    // const saved = localStorage.getItem('theme');
    // if (saved === 'dark') {
    //   this.theme.set('dark');
    // }
    // this.applyTheme();

    document.documentElement.classList.add('qds-theme-dark');
    document.documentElement.classList.add('qds-platform-desktop');
    
    this.toastrService.toastrState$.subscribe(state => {
      this.toastrState = state;
    });
  }

  hideToastr() {
    this.toastrService.hide();
  }

  ngOnInit() {
    if (environment.production) {
      Logger.enableProductionMode();
    }


    const userLang = environment.supportedLanguages.findIndex(spt => spt.code === navigator.language) > -1 ? navigator.language : environment.defaultLanguage;
    this.i18nService.init(userLang, environment.supportedLanguages);
    const preferredLang = this.authService.getGlobalSavedPreferredLanguage;
    
    if (preferredLang) {
      this.i18nService.language = preferredLang;
    }
    
    const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));
    merge(this.translateService.onLangChange, onNavigationEnd)
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(event => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });
  }

  // private applyTheme() {
  //   document.body.classList.toggle('qds-theme-dark', this.theme() === 'dark');
  //   document.body.classList.toggle('qds-theme-light', this.theme() === 'light');
  // }

  // toggleTheme() {
  //   this.theme.set(this.theme() === 'light' ? 'dark' : 'light');
  //   localStorage.setItem('theme', this.theme());
  //   this.applyTheme();
  // }

}
